// Text measurement and layout round differently, so a row this close to full is treated as full.
const SLACK = 3;

/**
 * How many of an item's tags fit on its one-line row. Widths are each chip's outer width, margins
 * included; `gap` is the space the row puts between chips.
 */
export class TagRowFitter {
    /**
     * As many tags as fit whole, from the first. When some are left out, the "+N more" chip needs room
     * too. At least one tag shows, cut off with an ellipsis if even it does not fit.
     */
    countTagsThatFit = ({ rowWidth, leadingWidth, tagWidths, moreChipWidth, gap }: {
        rowWidth: number;
        // a chip shown before the tags, such as the AI icon on a task made from a recording
        leadingWidth?: number;
        tagWidths: number[];
        moreChipWidth: number;
        gap: number;
    }): number => {
        if (tagWidths.length === 0) {
            return 0;
        }

        const available = rowWidth - SLACK - (leadingWidth === undefined ? 0 : leadingWidth + gap);

        // where each tag ends, measured from the first tag's start
        const ends: number[] = [];
        tagWidths.forEach((width, index) => {
            ends.push(index === 0 ? width : ends[index - 1] + gap + width);
        });

        if (ends[ends.length - 1] <= available) {
            return tagWidths.length;
        }

        let count = Math.max(1, tagWidths.length - 1);
        while (count > 1 && ends[count - 1] + gap + moreChipWidth > available) {
            count--;
        }
        return count;
    };
}
